import { Container, Section } from '@repo/ui'
import { createFileRoute } from '@tanstack/react-router'
import { lazy, Suspense } from 'react'

const PrivacyPage = lazy(() =>
  import('@/features/legal/privacy-page').then((mod) => ({ default: mod.PrivacyPage }))
)

const PrivacySkeleton = () => (
  <Section variant="default" className="md:pt-24">
    <Container size="prose">
      <div className="space-y-6">
        <div className="h-10 w-3/4 animate-pulse rounded bg-muted" />
        <div className="space-y-3">
          <div className="h-4 w-full animate-pulse rounded bg-muted/80" />
          <div className="h-4 w-11/12 animate-pulse rounded bg-muted/70" />
          <div className="h-4 w-5/6 animate-pulse rounded bg-muted/60" />
        </div>
      </div>
    </Container>
  </Section>
)

export const Route = createFileRoute('/privacy')({
  component: () => (
    <Suspense fallback={<PrivacySkeleton />}>
      <PrivacyPage />
    </Suspense>
  ),
})
